<figure *ngIf="data">
    <da-progressive-image [options]="progressiveImageOptions"></da-progressive-image>
    <figcaption *ngIf="(data.button && data.button.text) || data.headline">
        <div class="captioncontainer">
            <div class="caption">
                <ng-container *ngIf="data.headline">
                    <h2 [innerHTML]="data.headline"></h2>
                </ng-container>
                <ng-container *ngIf="data.button && data.button.text !== '' && data.button.url.imageUrl !== ''">
                    <a da-button [link]="data.button?.url.imageUrl" [themeType]="'Primary'" [innerHtml]="data.button?.text"></a>
                </ng-container>
            </div>
        </div>
    </figcaption>
</figure>
